import * as types from '../mutation-types'
import feathersClient, { Roles, Users } from '@/feathers'
import find from 'lodash/find'
import intersection from 'lodash/intersection'
import includes from 'lodash/includes'
import merge from 'lodash/merge'
import axios from 'axios'

const state = {
  currentUser: {
    data: null,
    error: null,
    loading: false
  },
  currentOrgId: null,
  roles: []
}

const getters = {
  hasRoles (state) {
    return function (roles) {
      const userRoles = find(state.currentUser.data.organizations, { id: state.currentOrgId }).roles
      return includes(userRoles, 'superAdmin') ? true : intersection(userRoles, roles).length > 0
    }
  },
  availableRoles (state) {
    if (state.currentUser && state.currentUser.data && state.currentUser.data.organizations && state.currentOrgId) {
      const org = state.currentUser.data.organizations.find(item => {
        return item.id === state.currentOrgId
      })
      if (org && includes(org.roles, 'superAdmin')) {
        return state.roles
      } else if (org) {
        return state.roles.filter(role => includes(org.roles, role.id))
      }
    }
  }
}

const actions = {
  login ({ commit, dispatch }, { email, password }) {
    let user = null
    commit(types.LOGIN_USER_REQUEST)
    return feathersClient.authenticate({
      strategy: 'local',
      email: email,
      password: password
    }).then(response => {
      user = response.user
      return Promise.all([feathersClient.passport.verifyJWT(response.accessToken), Promise.resolve(response.accessToken)])
    }).then(([payload, jwt]) => {
      axios.defaults.headers.common['Authorization'] = jwt
      feathersClient.set('user', user)
      commit(types.LOGIN_USER_SUCCESS, { user })
      commit(types.SET_CURRENT_USER_ORGID, {orgId: user.organizations[0].id})
      return Users.get(user.id, { orgId: user.organizations[0].id })
    }).then(res => {
      merge(user, res)
      commit(types.LOGIN_USER_SUCCESS, { user })
      return user
    }).catch(error => {
      commit(types.LOGIN_USER_FAILURE, { error })
      return Promise.reject(error)
    })
  },
  logout ({ commit, rootState, dispatch }) {
    return feathersClient.logout().then(function () {
      commit(types.RESET_CURRENT_USER)
      localStorage.removeItem('feathers-jwt')
      delete axios.defaults.headers.common['Authorization']
      dispatch('reset', null, {root: true})
    })
  },
  getRoles ({ commit, dispatch }) {
    return Roles.find().then(roles => {
      commit(types.SET_ROLES, { roles })
    })
  },
  changeOrg ({commit, state, dispatch}, orgId) {
    if (!orgId) {
      orgId = state.currentOrgId
    }
    const org = state.currentUser.data.organizations.find((u) => Number(u.id) === Number(orgId))
    commit(types.SET_CURRENT_USER_ORGID, {orgId})
    if (org.logo) {
      dispatch('changeLogo', {orgId, orgLogo: org.logo})
    }
    if (org.title) {
      commit(types.SET_CURRENT_TITLE, org.title)
    } else {
      commit(types.SET_CURRENT_TITLE, 'IPCOM VORTEX')
    }
  }
}

const mutations = {
  [types.SET_CURRENT_USER] (state, { user }) {
    state.currentUser.data = user
    state.currentUser.error = null
    state.currentUser.loading = false
  },

  [types.SET_CURRENT_USER_ORGID] (state, { orgId }) {
    if (state.currentOrgId !== orgId) {
      state.currentOrgId = orgId
    }
  },

  [types.LOGIN_USER_REQUEST] (state) {
    state.currentUser.loading = true
  },

  [types.LOGIN_USER_SUCCESS] (state, { user }) {
    state.currentUser.data = user
    state.currentUser.error = null
    state.currentUser.loading = false
  },

  [types.LOGIN_USER_FAILURE] (state, { error }) {
    state.currentUser.loading = false
    state.currentUser.error = error
  },

  [types.RESET_CURRENT_USER] (state) {
    state.currentUser = {
      data: {},
      error: null,
      loading: false
    }
    state.currentOrgId = null
  },

  [types.RESET_CURRENT_USER_LOADING] (state) {
    state.currentUser.loading = false
  },

  [types.SET_ROLES] (state, { roles }) {
    state.roles = roles
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js